import { shallowEqual, useSelector } from "react-redux"
import { RootState } from "../setup"

function useAccessToken() {
    return String(useSelector<RootState>(({ auth }) => auth.accessToken, shallowEqual))
}

export default useAccessToken